import { StyleSheet } from '@react-pdf/renderer'

export const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 10,
    lineHeight: 1.4,
  },
  header: {
    position: 'absolute',
    height: 30,
    backgroundColor: '#FFFFFF',
    color: 'black',
    padding: 8,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #00BFD4'
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 40,
    right: 40,
    height: 30,
    backgroundColor: '#f3f4f6',
    padding: 8,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: '1px solid #d1d5db',
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
    color: '#1e40af',
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginTop: 20,
    marginBottom: 10,
    color: '#374151',
    borderBottom: '2px solid #e5e7eb',
    paddingBottom: 5,
  },
  dataGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 15,
  },
  dataItem: {
    width: '50%',
    flexDirection: 'row',
    marginBottom: 8,
  },
  label: {
    width: '40%',
    fontWeight: 'bold',
    color: '#4b5563',
    fontSize: 9,
  },
  value: {
    width: '60%',
    color: '#111827',
    fontSize: 9,
  },
  englishLabel: {
    fontSize: 7,
    color: '#6b7280',
    fontStyle: 'italic',
  },
  structureContainer: {
    marginTop: 15,
    marginBottom: 15,
  },
  structureName: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 8,
    color: '#1e40af',
    backgroundColor: '#eff6ff',
    padding: 5,
    borderRadius: 3,
  },
  table: {
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#d1d5db',
    marginBottom: 10,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#d1d5db',
  },
  tableHeader: {
    backgroundColor: '#f3f4f6',
    fontWeight: 'bold',
  },
  tableCell: {
    padding: 6,
    borderRightWidth: 1,
    borderRightColor: '#d1d5db',
    fontSize: 8,
  },
  tableCellLast: {
    padding: 6,
    fontSize: 8,
  },
  headerText: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  footerText: {
    fontSize: 8,
    color: '#6b7280',
  },
  signatureSection: {
    marginTop: 30,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  signatureBox: {
    width: '45%',
    borderTopWidth: 1,
    borderTopColor: '#d1d5db',
    paddingTop: 10,
    alignItems: 'center',
  },
  signatureText: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  signatureLine: {
    width: '80%',
    borderTopWidth: 1,
    borderTopColor: '#000',
    marginTop: 20,
  },
  // Estilos para páginas de imagem
  imagePageContent: {
    padding: 40,
    paddingTop: 60,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
    color: '#1e40af',
  },
  imageSubtitle: {
    fontSize: 12,
    color: '#6b7280',
    marginBottom: 20,
    textAlign: 'center',
    fontStyle: 'italic',
  },
  imageContainer: {
    width: '100%',
    maxWidth: 500,
    marginBottom: 30,
    alignItems: 'center',
  },
  certificateImage: {
    width: '100%',
    height: 'auto',
    maxHeight: 400,
    objectFit: 'contain',
  },
  imageInfo: {
    width: '100%',
    alignItems: 'center',
    marginTop: 20,
  },
  imageInfoText: {
    fontSize: 10,
    color: '#4b5563',
    marginBottom: 5,
  },
});